import { createGlobalStyle, css } from 'styled-components';

import { Colour } from '@xemplo/colours';

/**
 * For the most part, the original implementation works correctly
 * cross-browser. Have come across a situation where it doesn't.
 * I'm exposing the scrolling styles as a separate export so that it can be
 * applied to specific components that require it, rather than globally.
 */
export const Scrolling = css`
  /**
   * Standard CSS Scrollbars (scrollbar-width/scrollbar-color/scrollbar-gutter).
   * Firefox only. Chrome, Edge and Opera currently prioritise the
   * ::-webkit-scrollbar* rules below over these standard properties, even
   * though Chromium/Edge also support them.
   * Not supported at all in Safari.
   */
  html {
    scrollbar-width: thin;
    scrollbar-color: ${Colour.Clarity.Grey.Soft} transparent;
    scrollbar-gutter: auto;
  }

  /**
   * ::-webkit-scrollbar* (non-standard).
   * Chrome, Edge, Opera, Safari (all WebKit/Blink browsers). Ignored entirely
   * by Firefox, which has never implemented these pseudo-elements.
   */
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: ${Colour.Clarity.Base.White};
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: ${Colour.Clarity.Grey.Soft};
    border-radius: 5px;
  }
  /* Handle on hover (no standard-CSS equivalent, WebKit/Blink only) */
  ::-webkit-scrollbar-thumb:hover {
    background: ${Colour.Clarity.Grey.Medium};
  }
`;

const Style = createGlobalStyle`
/*
 * Inter is loaded through the official Google Fonts CSS API in app bootstrap
 * (see useGlobalFont in @xemplo/app-bootstrap), not via hardcoded
 * fonts.gstatic.com @font-face blocks. This file only declares font usage.
 */
html {
  margin:0;
  padding:0;
}

body {
  margin: 0;
  font-family: Inter,BlinkMacSystemFont,-apple-system,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",Helvetica,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #373737;
  background-color: var(--color-background-body, ${Colour.Clarity.Background.Backdrop});
  overflow-x: hidden;
  overscroll-behavior: contain;

  font-size: 0.875rem;
}

p {
  margin-top: 16px
}

${Scrolling};
`;

export default Style;
